/**
 * Format byte size to human-readable string.
 */
export function formatSize(bytes: number): string {
	if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
	if (bytes >= 1024) return `${(bytes / 1024).toFixed(0)} KB`
	return `${bytes} bytes`
}
